module.exports = __webpack_public_path__ + "assets/4edd127a5e670704bca1e5679dc8950a.svg";